// SHARED-006: Agent stat calculation formulas
// Used by Phase 1 (calculation) and Phase 3 (verification)

export const AgentStatCalc = {
  /** ATK = baseATK * (1 + 0.08 * (level-1)) — GDD §4.8.2 */
  calcAttack(baseATK: number, level: number): number {
    return Math.round(baseATK * (1 + 0.08 * (level - 1)));
  },

  /** DEF = baseDEF * (1 + 0.08 * (level-1)) — GDD §4.8.2 */
  calcDefense(baseDEF: number, level: number): number {
    return Math.round(baseDEF * (1 + 0.08 * (level - 1)));
  },

  /** HP = baseHP * (1 + 0.05 * (level-1)) — GDD §4.8.2 */
  calcHP(baseHP: number, level: number): number {
    return Math.round(baseHP * (1 + 0.05 * (level - 1)));
  },

  /** critRate = 5 + rarity * 2 (percent) — GDD §4.5.4 */
  calcCritRate(rarity: number): number {
    return 5 + rarity * 2;
  },

  /** computeCost = base + (rarity-1)*0.5 + (level/10), ceil — GDD §4.3.4 */
  calcComputeCost(baseCost: number, rarity: number, level: number): number {
    return Math.ceil(baseCost + (rarity - 1) * 0.5 + level / 10);
  },

  /** Max level = rarity * 10 — GDD §4.8.2 */
  maxLevel(rarity: number): number {
    return rarity * 10;
  },
};
